module.exports = __webpack_public_path__ + "img/03_full.10e0b9f2.jpg";